(() => {
  /* ---------------- helpers ---------------- */
  const debounce = (fn, wait = 200) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const escapeHtml = (str) =>
    String(str).replace(/[&<>"']/g, (m) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[m]));

  const escapeRegExp = (str) =>
    String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const highlightHtml = (text) => {
  return escapeHtml(text);
};


  /* ---------------- custom live search dropdown (DISABLED) ----------------
     You chose to keep Shopify original predictive search, so we do nothing here.
  */
  const forms = document.querySelectorAll('form[data-live-search]');
  // (Intentionally no return)

  /* ---------------- highlight on search results page (ALWAYS RUN) ---------------- */
  const runHighlight = () => {
    const q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (!q) return;

    // Try common theme title-link selectors first
    const selectors = [
      '.card__heading a',
      'a.full-unstyled-link',
      '.product-card__title a',
      '.grid-product__title a',
      '.product-item__title a',
      '.product-title a',
    ];

    let links = Array.from(document.querySelectorAll(selectors.join(',')));

    // Fallback: any /products/ links inside main content
    if (!links.length) {
      links = Array.from(
        document.querySelectorAll('#MainContent a[href*="/products/"], main a[href*="/products/"]')
      );
    }

    links.forEach((a) => {
      const text = (a.textContent || '').trim();
      if (!text) return;
      a.innerHTML = highlightHtml(text, q);
    });
  };

  // Run after page is ready (and once more after a short delay for themes that render late)
  document.addEventListener('DOMContentLoaded', runHighlight);
  window.addEventListener('load', runHighlight);
  setTimeout(runHighlight, 500);
})();
